export default __webpack_public_path__ + "static/media/translator-screenshot-01.78248eca.png";